import { get } from 'lodash';

export const populateVars = (text: string, referenceObject: any, decorator: null | ((text: string) => string)) => {
	const matches = [...text.matchAll(/\[\[=(.*?)\]\]/g)].map((m) => m[1]);

	matches.forEach((match) => {
		text = text.replace(`[[=${match}]]`, get(referenceObject, match));
	});

	if (decorator) {
		text = decorator(text);
	}

	return text;
};

export const currencyWrap = (text: string) => text.replace(/([^ ]* EUR)/g, '<span class="nowrap">$1</span>');
